module.exports = __webpack_public_path__ + "img/15.475a17ac.png";